/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.openGraphModule', ['bulbApp.configModule'])

.constant('OPEN_GRAPH', {
  defaultImage: {
    url: 'resources/images/bulb_logo_social_media_default.jpg',
    width: 478,
    height: 250
  }
})

.value('openGraphValues', {
  'og:site_name': 'bulb'
})

.run(['$rootScope', 'openGraphValues', 'OPEN_GRAPH', function($rootScope, openGraphValues, OPEN_GRAPH) {
  openGraphValues['og:image'] = OPEN_GRAPH.defaultImage.url;
  openGraphValues['og:image:width'] = OPEN_GRAPH.defaultImage.width;
  openGraphValues['og:image:height'] = OPEN_GRAPH.defaultImage.height;

  $rootScope.$watch('$title', function(newTitle) {
    if (!newTitle) {
      openGraphValues['og:title'] = 'bulb';
    } else {
      openGraphValues['og:title'] = newTitle;
    }
  });
}]);
